export default __webpack_public_path__ + "static/media/Canon.2fa3ca8b.png";